export function InitContactEvents(wpcf7Form) {

    // Mise a jour du dataLayer une fois le mail envoyé
    
    document.addEventListener( 'wpcf7mailsent', function( event ) {
        var inputs = event.detail.inputs;
        var projectType = [];
      
        for ( var i = 0; i < inputs.length; i++ ) {
            if ( "project_type[]" === inputs[i].name ) {
                projectType.push(inputs[i].value)
            }
        }

        // mise à jour du dataLayer
        window.dataLayer.push({
            "event":"devis-form-success",
            "project_type" : projectType.toString()
        });

  }, false );
}